import { Card } from '@lilith-arcana-os/ui';

import type { ReadingRecord } from '@lilith-arcana-os/domain';

interface HistoryListProps {
  items: ReadingRecord[];
}

export function HistoryList({ items }: HistoryListProps) {
  if (items.length === 0) {
    return (
      <Card eyebrow="Archivio" title="Nessuna lettura salvata">
        <p className="text-sm text-[var(--la-text-muted)]">
          Le letture salvate appariranno qui appena il flusso `history/save` viene usato.
        </p>
      </Card>
    );
  }

  return (
    <div className="grid gap-4">
      {items.map((item) => (
        <Card
          eyebrow={new Date(item.created_at).toLocaleString('it-IT')}
          key={item.id ?? `${item.spread_id}-${item.created_at}`}
          title={item.spread_name}
        >
          <p className="text-base text-[var(--la-text)]">{item.question}</p>
          <p className="mt-2 text-sm text-[var(--la-text-muted)]">{item.interpretation.synthesis}</p>
        </Card>
      ))}
    </div>
  );
}
